import React, { useState, useEffect } from 'react';
import styles from './DetailedGroupModal.module.css';

const DetailedGroupModal = ({ isOpen, onClose, group, items, onUngroup }) => {
  const [groupedItems, setGroupedItems] = useState({});

  useEffect(() => {
    if (items && items.length > 0) {
      // Group items by their group_id
      const grouped = items.reduce((acc, item) => {
        const groupId = item.group_id || 'Ungrouped';
        if (!acc[groupId]) {
          acc[groupId] = [];
        }
        acc[groupId].push(item);
        return acc;
      }, {});
      setGroupedItems(grouped);
    }
  }, [items]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleUngroup = (item) => {
    if (window.confirm(`Are you sure you want to ungroup "${item.description}"?`)) {
      onUngroup(item);
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <div>
            <h2>Detailed Group View</h2>
            <p className={styles.groupInfo}>
              <strong>{group?.description}</strong> (ID: {group?.generalGroupId})
            </p>
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          {Object.keys(groupedItems).length === 0 ? (
            <div className={styles.noData}>No items found</div>
          ) : (
            Object.entries(groupedItems).map(([groupId, groupItems]) => (
              <div key={groupId} className={styles.subGroupSection}>
                <div className={styles.subGroupHeader}>
                  <h3> {groupId}</h3>
                  <span className={styles.itemCount}>
                    {groupItems.length} {groupItems.length === 1 ? 'item' : 'items'}
                  </span>
                </div>

                <div className={styles.tableContainer}>
                  <table className={styles.table}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Description</th>
                        <th>Code</th>
                        <th>Type</th>
                        <th>Category</th>
                        <th>Color</th>
                        <th>Size</th>
                        <th>Price</th>
                        <th>Wholesale</th>
                        <th>Quantity</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupItems.map((item, index) => (
                        <tr key={item.sno || index}>
                          <td>{index + 1}</td>
                          <td className={styles.description}>{item.description}</td>
                          <td>{item.itemCode}</td>
                          <td>{item.itemType}</td>
                          <td>{item.itemCategory || '-'}</td>
                          <td>{item.itemColor || '-'}</td>
                          <td>{item.itemSize || '-'}</td>
                          <td className={styles.price}>₹{item.price}</td>
                          <td className={styles.price}>₹{item.wholeSalePrice}</td>
                          <td className={styles.quantity}>{item.quantity}</td>
                          <td>
                            <span className={`${styles.statusBadge} ${styles[item.itemActiveStatus]}`}>
                              {item.itemActiveStatus}
                            </span>
                          </td>
                          <td>
                            <button
                              className={styles.ungroupButton}
                              onClick={() => handleUngroup(item)}
                              title="Remove item from group"
                            >
                              Ungroup
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          )}
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.closeBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DetailedGroupModal;